import { findSettingItemByPath } from "../data/settingSidebarCatalog";

export const USER_ROLE_PAGE_LINK_ID = "O17";
export const USER_ROLE_PAGE_PATH = "/operation/userRole";
export const SETTINGS_LINK_IDS = ["O9", "GI9", "M21"];

export function getUserRolePageAccess(userRole) {
  const entry = (userRole?.links ?? []).find(
    (link) => link.link === USER_ROLE_PAGE_LINK_ID
  );
  return Number(entry?.accessRight ?? 0);
}

export function canSeeUserRolePage(userRole) {
  return getUserRolePageAccess(userRole) > 0;
}

export function filterSettingsForRole(settings, userRole) {
  return (settings ?? []).filter((setting) => {
    if (setting.link === USER_ROLE_PAGE_PATH && !canSeeUserRolePage(userRole)) {
      return false;
    }
    const item = findSettingItemByPath(setting.link);
    if (!item) return true;
    const entry = (userRole?.links ?? []).find((link) => link.link === item.linkId);
    if (!entry) return true;
    return Number(entry.accessRight ?? 0) > 0;
  });
}
